import { EnumBase } from 'hay-core-react';
class HomologacaoIntegracaoObrigatoriedadeUrlEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.homologacaointegracao.obrigatoriedadeurl.desativado',
                'main.homologacaointegracao.obrigatoriedadeurl.opcional',
                'main.homologacaointegracao.obrigatoriedadeurl.obrigatorio',
            ],
            'main.homologacaointegracao.obrigatoriedadeurl.obrigatorio'
        );
    }
}

const instance = new HomologacaoIntegracaoObrigatoriedadeUrlEnum();
export default instance;
